// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Game.css */
.game-container {
  text-align: center;
  margin: 20px;
}

.grid {
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.grid__wrapper {
  width: fit-content;
  border: 2px solid #333;
}

.row {
  display: flex;
}

.cell {
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  font-size: 24px;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.cell__wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes moveDown  {
  0% {
    top: calc(-100% * var(--drop-down));
  }

  100% {
    top: 0;
  }
}

@keyframes moveAside  {
  0% {
    left: calc(100% * var(--start-direction));
  }

  100% {
    left: calc(100% * var(--end-direction));
  }
}

@keyframes moveFloor  {
  0% {
    top: calc(100% * var(--start-direction));
  }

  100% {
    top: calc(100% * var(--end-direction));
  }
}

.cell__wrapper_move {
  animation: moveDown calc(0.1s * var(--drop-down)) forwards;
  animation-timing-function: linear;
}

.cell__wrapper_switch_side {
  animation: moveAside 0.3s forwards;
  animation-timing-function: ease-in;
}

.cell__wrapper_switch_floor {
  animation: moveFloor 0.3s forwards;
  animation-timing-function: ease-out;
}

.play-button-container {
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}

.play-button {
  background-color: orange;
  color: white;
  border: none;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  font-size: 24px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.play-button:hover {
  background-color: white; /* Change background on hover */
  color: orange; /* Change text color on hover */
  transform: scale(1.1); /* Slightly enlarge the button on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/screens/game/Game.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,MAAM;EACR;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,0DAA0D;EAC1D,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;EACxD,aAAa,EAAE,+BAA+B;EAC9C,qBAAqB,EAAE,yCAAyC;AAClE","sourcesContent":["/* src/Game.css */\n.game-container {\n  text-align: center;\n  margin: 20px;\n}\n\n.grid {\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.grid__wrapper {\n  width: fit-content;\n  border: 2px solid #333;\n}\n\n.row {\n  display: flex;\n}\n\n.cell {\n  width: 50px;\n  height: 50px;\n  border: 1px solid #ccc;\n  font-size: 24px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  position: relative;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.cell__wrapper {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes moveDown  {\n  0% {\n    top: calc(-100% * var(--drop-down));\n  }\n\n  100% {\n    top: 0;\n  }\n}\n\n@keyframes moveAside  {\n  0% {\n    left: calc(100% * var(--start-direction));\n  }\n\n  100% {\n    left: calc(100% * var(--end-direction));\n  }\n}\n\n@keyframes moveFloor  {\n  0% {\n    top: calc(100% * var(--start-direction));\n  }\n\n  100% {\n    top: calc(100% * var(--end-direction));\n  }\n}\n\n.cell__wrapper_move {\n  animation: moveDown calc(0.1s * var(--drop-down)) forwards;\n  animation-timing-function: linear;\n}\n\n.cell__wrapper_switch_side {\n  animation: moveAside 0.3s forwards;\n  animation-timing-function: ease-in;\n}\n\n.cell__wrapper_switch_floor {\n  animation: moveFloor 0.3s forwards;\n  animation-timing-function: ease-out;\n}\n\n.play-button-container {\n  top: 0;\n  left: 0;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n}\n\n.play-button {\n  background-color: orange;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  font-size: 24px;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.3s;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n.play-button:hover {\n  background-color: white; /* Change background on hover */\n  color: orange; /* Change text color on hover */\n  transform: scale(1.1); /* Slightly enlarge the button on hover */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
